import { useContext } from 'react';

import { SettingsContext } from '../providers/settings';

export { defaultSettings } from '../providers/settings';

export function useSettings() {
  return useContext(SettingsContext);
}
